export class VoipImportFromSantralRequest {
  voipInternalId?: number;
  startDate?: Date;
  endDate?: Date;
  showEmptyDestination?: boolean;
}
